var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181651_12028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3526 3.50938L8.99014 0.146875C8.89639 0.053125 8.76982 0 8.63701 0H1.99951C1.72295 0 1.49951 0.223437 1.49951 0.5V13.5C1.49951 13.7766 1.72295 14 1.99951 14H11.9995C12.2761 14 12.4995 13.7766 12.4995 13.5V3.86406C12.4995 3.73125 12.4464 3.60313 12.3526 3.50938ZM11.3464 4.09375H8.40576V1.15313L11.3464 4.09375ZM11.3745 12.875H2.62451V1.125H7.34326V4.5C7.34326 4.67405 7.4124 4.84097 7.53547 4.96404C7.65854 5.08711 7.82546 5.15625 7.99951 5.15625H11.3745V12.875ZM6.87451 8.65625H3.99951C3.93076 8.65625 3.87451 8.7125 3.87451 8.78125V9.53125C3.87451 9.6 3.93076 9.65625 3.99951 9.65625H6.87451C6.94326 9.65625 6.99951 9.6 6.99951 9.53125V8.78125C6.99951 8.7125 6.94326 8.65625 6.87451 8.65625ZM3.87451 6.65625V7.40625C3.87451 7.475 3.93076 7.53125 3.99951 7.53125H9.99951C10.0683 7.53125 10.1245 7.475 10.1245 7.40625V6.65625C10.1245 6.5875 10.0683 6.53125 9.99951 6.53125H3.99951C3.93076 6.53125 3.87451 6.5875 3.87451 6.65625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181651_12028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSidebarIcon);
export default __webpack_public_path__ + "static/media/ProjectSidebarIcon.98a694ab673fa0e7a6326bb0e4957c32.svg";
export { ForwardRef as ReactComponent };